<template>
  <header class="headerPanel">
    <div class="logo">
      <a href="/panel/dashboard">
        <img
          src="../../assets/logo_integra.png"
          alt="Logo Profiz Leveros Integra"
        />
      </a>
    </div>
    <div class="searchOrder">
      <input
        type="text"
        placeholder="Consultar pedido"
        id="nrPedido"
        @change="getDados"
      />
      <button @click="getDados">
        <svg
          width="17"
          height="17"
          viewBox="0 0 17 17"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clip-path="url(#clip0)">
            <path
              d="M16.8962 16.3954L11.7237 11.2228C12.798 10.0299 13.4584 8.45714 13.4584 6.72914C13.4583 3.01873 10.4396 0 6.72918 0C3.01873 0 0 3.01873 0 6.72918C0 10.4396 3.01873 13.4584 6.72918 13.4584C8.45717 13.4584 10.0299 12.798 11.2229 11.7237L16.3954 16.8962C16.4646 16.9654 16.5552 17 16.6459 17C16.7365 17 16.8271 16.9654 16.8963 16.8962C17.0346 16.7579 17.0346 16.5338 16.8962 16.3954ZM6.72918 12.75C3.40956 12.75 0.708355 10.0491 0.708355 6.72918C0.708355 3.40923 3.40956 0.708322 6.72918 0.708322C10.0488 0.708322 12.75 3.4092 12.75 6.72918C12.75 10.0492 10.0488 12.75 6.72918 12.75Z"
              fill="#fff"
            />
          </g>
          <defs>
            <clipPath id="clip0">
              <rect width="17" height="17" fill="white" />
            </clipPath>
          </defs>
        </svg>
      </button>
      <p class="searchOrder--error">Pedido não encontrado!</p>
    </div>
    <div
      class="profitz"
      v-if="parceiros.length <= 0 && vendedorResponsavel != null"
    >
      <img
        src="../../assets/profitz-verde.png"
        alt="Ícone Profitz"
        width="25px"
      />

      <p>Profitz:</p>
      <span> {{ Math.round(card_balance) }}</span>
    </div>
    <div class="welcome">
      <svg
        width="25"
        height="25"
        viewBox="0 0 25 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M12.5 0.5C5.8835 0.5 0.5 5.8835 0.5 12.5C0.5 16.0455 2.047 19.236 4.5 21.4345V21.443L4.674 21.593C4.7045 21.6195 4.738 21.6415 4.769 21.6675C4.9845 21.8495 5.2065 22.024 5.4345 22.191C5.496 22.236 5.5575 22.2795 5.62 22.323C5.862 22.493 6.1095 22.655 6.3635 22.807C6.406 22.8325 6.4495 22.8565 6.492 22.881C6.7705 23.043 7.055 23.1955 7.347 23.335C7.35 23.3365 7.353 23.3375 7.356 23.339C7.9805 23.6365 8.6355 23.88 9.3135 24.067C9.326 24.0705 9.3385 24.0745 9.351 24.0775C9.6715 24.165 9.9975 24.2385 10.328 24.299C10.359 24.3045 10.3895 24.31 10.4205 24.3155C10.7395 24.3715 11.0625 24.416 11.39 24.4465C11.4275 24.45 11.465 24.452 11.502 24.455C11.8315 24.4825 12.1635 24.5 12.5 24.5C12.8365 24.5 13.1685 24.4825 13.498 24.455C13.5355 24.452 13.573 24.45 13.61 24.4465C13.9375 24.4165 14.2605 24.3715 14.5795 24.3155C14.6105 24.31 14.641 24.3045 14.672 24.299C15.0025 24.2385 15.3285 24.165 15.649 24.0775C15.6615 24.074 15.674 24.0705 15.6865 24.067C16.3645 23.88 17.0195 23.6365 17.644 23.339C17.647 23.3375 17.65 23.3365 17.653 23.335C17.945 23.1955 18.2295 23.0425 18.508 22.881C18.551 22.856 18.594 22.8325 18.6365 22.807C18.891 22.655 19.1385 22.4925 19.38 22.323C19.442 22.2795 19.504 22.236 19.5655 22.191C19.7935 22.024 20.0155 21.8495 20.231 21.6675C20.262 21.6415 20.2955 21.6195 20.326 21.593L20.5 21.443V21.4345C22.953 19.2355 24.5 16.0455 24.5 12.5C24.5 5.8835 19.1165 0.5 12.5 0.5ZM12.5 12.5C10.2945 12.5 8.5 10.7055 8.5 8.5C8.5 6.2945 10.2945 4.5 12.5 4.5C14.7055 4.5 16.5 6.2945 16.5 8.5C16.5 10.7055 14.7055 12.5 12.5 12.5ZM14 13.5C17.0325 13.5 19.5 15.9675 19.5 19V20.979C19.479 20.9965 19.457 21.0125 19.436 21.03C19.2385 21.1905 19.036 21.343 18.829 21.489C18.783 21.5215 18.738 21.555 18.692 21.5865C18.4685 21.739 18.239 21.882 18.0055 22.0175C17.963 22.0425 17.92 22.067 17.877 22.0915C17.632 22.229 17.3825 22.358 17.128 22.476C17.1015 22.4885 17.0745 22.5005 17.0475 22.5125C16.217 22.89 15.342 23.1635 14.4415 23.3255C14.413 23.3305 14.3845 23.336 14.356 23.341C14.0725 23.3895 13.7865 23.427 13.4985 23.4535C13.459 23.457 13.419 23.4595 13.379 23.4625C13.0875 23.485 12.7945 23.5 12.5 23.5C12.2055 23.5 11.9125 23.485 11.621 23.4615C11.5815 23.4585 11.5415 23.456 11.5015 23.4525C11.2135 23.426 10.9275 23.389 10.644 23.34C10.6155 23.335 10.587 23.33 10.5585 23.3245C9.658 23.1625 8.783 22.889 7.9525 22.5115C7.9255 22.499 7.8985 22.4875 7.872 22.475C7.6175 22.357 7.368 22.228 7.123 22.0905C7.08 22.066 7.0375 22.0415 6.9945 22.0165C6.761 21.8815 6.5315 21.738 6.308 21.5855C6.2615 21.554 6.2165 21.5205 6.171 21.488C5.964 21.342 5.7615 21.19 5.564 21.029C5.543 21.012 5.521 20.9955 5.5 20.978V19C5.5 15.9675 7.9675 13.5 11 13.5H14ZM20.5 20.038V19C20.5 15.8645 18.268 13.2405 15.31 12.6325C16.6305 11.732 17.5 10.2155 17.5 8.5C17.5 5.743 15.257 3.5 12.5 3.5C9.743 3.5 7.5 5.743 7.5 8.5C7.5 10.2155 8.3695 11.732 9.69 12.6325C6.732 13.2405 4.5 15.8645 4.5 19V20.038C2.642 18.0675 1.5 15.4155 1.5 12.5C1.5 6.4345 6.4345 1.5 12.5 1.5C18.5655 1.5 23.5 6.4345 23.5 12.5C23.5 15.4155 22.358 18.0675 20.5 20.038Z"
          fill="#002D32"
        />
      </svg>

      <p>Seja bem-vindo(a),</p>
      <span> {{ nomeUsuario }}</span>
    </div>
  </header>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      nomeUsuario: null,
      parceiros: [],
      perfis: [],
      vendedorResponsavel: null,
      token: null,
      infos: null,
      card_balance: 0,
    };
  },
  methods: {
    async getDados() {
      let dados = JSON.parse(localStorage.getItem("login"));
      let canal = JSON.parse(localStorage.getItem("saleChannel"));
      //Consulta Profitz
      try {
        axios
          .get(`https://leverosintegra.dev.br/api/bcdigital/registerOld/${dados.cpfCnj}`)
          .then((res) => {
            if (res.data == "") {
              this.card_balance = 0;
            } else {
              this.card_balance = res.data.card_balance / 100;
            }
          });
      } catch (e) {
        console.log("profitz", e);
      }

      this.nomeUsuario = dados.nomeUsuarioLogado;

      this.vendedorResponsavel = dados.vendedorResponsavel;

      if (dados.Parceiros != undefined) {
        this.parceiros = dados.Parceiros.filter(par => par.saleChannel === parseInt(canal));
      }

      let perfil = dados.perfil.find((x) => x.NomePerfil == "VENDEDOR");

      if (perfil != undefined && perfil != null) {
        this.vendedor = true;
      }

      if (dados != undefined) {
        this.token = dados.token;
      } else {
        this.token = "";
      }

      let numPedido;

      if (document.getElementById("nrPedido") != null) {
        numPedido = document.getElementById("nrPedido").value;
      }

      try {
        if (numPedido != null) {
          const response = await axios.get(
            `https://www.leverosintegra.com.br/MAP/api/pedido/${numPedido}-token${this.token}`
          );

          this.infos = response.data;

          let pedido = this.infos;

          if (pedido == "") {
            document.getElementsByClassName(
              "searchOrder--error"
            )[0].style.display = "block";
          }

          pedido.find(function (x) {
            if (x.NRPedido.substr(4) == numPedido) {
              window.location.href = `/panel/orders/DetailsOrder?Pedido=${numPedido}`;
            }
          });
        }
      } catch (e) {
        console.log(e);
      }
    },
  },

  async created() {
    try {
      let dados = JSON.parse(localStorage.getItem("login"));
      this.token = dados.token;
      
      if (
        window.location.pathname == window.location.pathname &&
        this.token == null
      ) {
        window.location.href = `/login?urlCallBack=${window.location.pathname}`;
      }
    } catch (e) {
      if (
        window.location.pathname == window.location.pathname &&
        this.token == null
      ) {
        window.location.href = `/login?urlCallBack=${window.location.pathname}`;
      }

      console.log(e);
    }
  },

  beforeMount() {
    this.getDados();
  },
};
</script>

<style lang="scss" scoped>
.headerPanel {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  justify-content: space-between;
  padding: 10px 15px;
  box-shadow: 0 2px 10px var(--customGray-100);
  flex-direction: column;

  @media (min-width: 441px) {
    flex-direction: row;
  }

  .logo {
    padding: 0;

    @media (min-width: 441px) {
      padding-left: 60px;
    }
  }

  .searchOrder {
    display: flex;
    align-items: center;
    padding: 20px 0 10px 0;

    @media (min-width: 441px) {
      padding: 0;
    }

    input {
      border: 1px solid var(--customGray-200);
      border-radius: 5px 0 0 5px;
      padding: 6px 10px;
      outline: none;
      font-size: 0.95rem;
    }

    button {
      background: var(--standardGreen);
      padding: 6px;
      border-radius: 0 5px 5px 0;
      outline: none;

      svg {
        vertical-align: middle;
      }
    }

    &--error {
      display: none;
      font-weight: bold;
      color: red;
      padding-left: 10px;
    }
  }

  .profitz {
    display: flex;
    align-items: center;
    flex-direction: column;
    position: absolute;
    right: 20px;
    top: 20px;

    @media (min-width: 441px) and (max-width: 866px) {
      position: initial;
      right: initial;
      top: initial;
    }

    @media (min-width: 867px) {
      flex-direction: row;
      position: initial;
      right: initial;
      top: initial;
    }

    p {
      padding: 0 5px 0 10px;
      display: none;

      @media (min-width: 441px) {
        display: block;
      }
    }

    span {
      font-weight: bold;
      color: var(--customDarkGreen);
    }
  }

  .welcome {
    display: none;

    @media (min-width: 681px) {
      display: flex;
      align-items: center;
    }

    @media (max-width: 866px) {
      flex-direction: column;
    }

    p {
      padding: 0 5px 0 10px;
      font-size: 0.95rem;
    }

    span {
      color: var(--drakGreen);
      font: 800 0.95rem "Soleto", sans-serif;
    }
  }
}
</style>